<script>
import ConversationCard from './widgets/conversation/ConversationCard.vue';
import { getUnattendedAlertLevel } from '../helper/unattendedConversationHelper';

export default {
  components: {
    ConversationCard,
  },
  inject: [
    'selectConversation',
    'deSelectConversation',
    'assignAgent',
    'assignTeam',
    'assignLabels',
    'updateConversationStatus',
    'toggleContextMenu',
    'markAsUnread',
    'markAsRead',
    'assignPriority',
    'isConversationSelected',
    'deleteConversation',
  ],
  props: {
    source: {
      type: Object,
      required: true,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nowInSeconds: Math.floor(Date.now() / 1000),
      unattendedTimerId: null,
    };
  },
  computed: {
    unattendedAlertLevel() {
      return getUnattendedAlertLevel(this.source, this.nowInSeconds);
    },
  },
  mounted() {
    this.unattendedTimerId = window.setInterval(() => {
      this.nowInSeconds = Math.floor(Date.now() / 1000);
    }, 30000);
  },
  beforeDestroy() {
    if (this.unattendedTimerId) {
      window.clearInterval(this.unattendedTimerId);
    }
  },
  beforeUnmount() {
    if (this.unattendedTimerId) {
      window.clearInterval(this.unattendedTimerId);
    }
  },
};
</script>

<template>
  <ConversationCard
    :key="source.id"
    :active-label="label"
    :team-id="teamId"
    :folders-id="foldersId"
    :chat="source"
    :conversation-type="conversationType"
    :selected="isConversationSelected(source.id)"
    :show-assignee="showAssignee"
    :unattended-alert-level="unattendedAlertLevel"
    enable-context-menu
    @select-conversation="selectConversation"
    @de-select-conversation="deSelectConversation"
    @assign-agent="assignAgent"
    @assign-team="assignTeam"
    @assign-label="assignLabels"
    @update-conversation-status="updateConversationStatus"
    @context-menu-toggle="toggleContextMenu"
    @mark-as-unread="markAsUnread"
    @mark-as-read="markAsRead"
    @assign-priority="assignPriority"
    @delete-conversation="deleteConversation"
  />
</template>